import { render, staticRenderFns } from "./ReviewAndRatingWidget.vue?vue&type=template&id=2eb0cebc"
import script from "./ReviewAndRatingWidget.vue?vue&type=script&lang=js"
export * from "./ReviewAndRatingWidget.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndRatingWidget.vue?vue&type=style&index=0&id=2eb0cebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports